"use client";
import DownloadIcon from "@mui/icons-material/Download";
import React from "react";
import SongRenameDialog from "~/components/audio/SongRenameDialog";
import type {
  GetSongActions,
  SongAction,
} from "~/components/audio/songActions.types";
import { adminOrdersService } from "~/connectors/orders.connector";
import {
  adminSongsService,
  customerSongsService,
} from "~/connectors/songs.connector";
import type { Song } from "~/types";
import AdminSongViews from "./AdminSongViews";


export const getAdminOrderSongActions: GetSongActions = (
  song: Song,
  { router, getState },
): SongAction[] => {
  const handleDownload = async () => {
    try {
      await customerSongsService.downloadSong(song.id);
    } catch (err) {
      console.error("Download error:", err);
      alert("Eroare la descărcarea fișierului");
    }
  };

  const handleRename = async (songId: string, title: string) => {
    const orderId = parseInt(songId, 10);
    if (isNaN(orderId)) throw new Error("ID invalid");
    await adminOrdersService.updateOrder(orderId, { songName: title });
    getState().updateCurrentSong({ title });
  };

  const handleCopyToDemo = async () => {
    const orderId = song.orderId;
    if (!orderId) return;
    try {
      const demo = await adminSongsService.copyToDemo(orderId);
      getState().setBigPlayerOpen(false);
      router.push(`/admin/demos/edit/${encodeURIComponent(demo.slug)}`);
    } catch (err) {
      console.error("Copy to demo error:", err);
      const message = err instanceof Error ? err.message : "Eroare necunoscută";
      alert(`Eroare la copierea la demo: ${message}`);
    }
  };

  const actions: SongAction[] = [
    {
      buttonProps: {
        children: <AdminSongViews song={song} />,
        onClick: () => { }, // No action, just display views
        sx: { pointerEvents: "none" },
      },
      visible: !!song.views && song.views > 0,
    },
    { panel: "lyrics", visible: !!song.lyrics },
    {
      buttonProps: {
        startIcon: React.createElement(DownloadIcon),
        children: "Descarcă",
        onClick: () => void handleDownload(),
      },
      visible: !!song.downloadable,
    },
    {
      inContextMenu: true,
      contextMenuLabel: "Schimbă titlul",
      DialogComponent: ({ song: s, onClose }) =>
        React.createElement(SongRenameDialog, {
          song: s,
          onClose,
          onSave: handleRename,
        }),
      visible: true,
    },
    {
      inContextMenu: true,
      contextMenuLabel: "Copiază la demo",
      onContextMenuClick: () => void handleCopyToDemo(),
      visible: !!song.orderId,
    },
    {
      inContextMenu: true,
      contextMenuLabel: "Vezi comanda",
      onContextMenuClick: () => {
        getState().setBigPlayerOpen(false);
        router.push(`/admin/comenzi/${song.orderId}`);
      },
      visible: !!song.orderId,
    },
  ];

  return actions;
};
